import { useEffect, useState } from "react";
export const useScript = ({ sdkLink, attributes }) => {
    const [scriptStatus, setScriptStatus] = useState("loading");
    useEffect(() => {
        const loadedScript = document.querySelector(`script[src="${sdkLink}"]`);
        const domScriptStatus = loadedScript?.getAttribute("data-status");
        if (domScriptStatus) {
            setScriptStatus(domScriptStatus);
            return;
        }
        if (loadedScript === null) {
            const script = document.createElement("script");
            script.src = sdkLink;
            script.async = true;
            if (attributes !== undefined) {
                const attributesKeys = Object.keys(attributes);
                attributesKeys.forEach((scriptAttribute) => {
                    script[scriptAttribute] = attributes[scriptAttribute];
                });
            }
            script.setAttribute("data-status", "loading");
            document.body.appendChild(script);
            const updateStatus = (status) => {
                script.setAttribute("data-status", status);
                setScriptStatus(status);
            };
            const removeEventListeners = () => {
                script.removeEventListener("load", handleScriptLoad);
                script.removeEventListener("error", handleScriptError);
            };
            const handleScriptLoad = () => {
                updateStatus("ready");
                removeEventListeners();
            };
            const handleScriptError = () => {
                updateStatus("error");
                removeEventListeners();
            };
            script.addEventListener("load", handleScriptLoad);
            script.addEventListener("error", handleScriptError);
            return () => {
                script.remove();
                removeEventListeners();
            };
        }
        else {
            setScriptStatus("unknown");
        }
    }, [attributes, sdkLink]);
    return { scriptStatus };
};
//# sourceMappingURL=useScript.js.map